<template >
  <div class="container">
    <patient-info-form
      @save="editPatient"
      @cancel="cancelEditPatient"
      :formData="patient"
      v-loading.fullscreen.lock="fullscreenLoading" />

    <!-- Cancel Create Dialog -->
    <el-dialog :visible.sync="control.showCancelCreateDialog" :closeOnClickModal="false" :showClose="false" style="margin-top: 19vh;" width="30%">
      <div style="display: flex; justify-content: row; align-items: center; margin-top: 30px;">
        <img width="38" height="38" src="https://storage.healthathome.in.th/87d115c7-a7c9-48f0-a2c7-23728a96f917.svg" />
        <div class="dialog-header-18" style="margin-left: 17px;">คุณต้องการยกเลิกการอัพเดตข้อมูล ?</div>
      </div>
      <span class="dialog-footer" slot="footer">
        <el-button class="cancel-button" @click="handleCancel(false)">ไม่</el-button>
        <el-button type="primary" @click="handleCancel(true)" class="edit">ใช่</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
  .container {
    padding-left: 200px;
    padding-right: 200px;
  }
</style>

<script>
import PatientInfoForm from '@/components/patient/form/PatientInfoForm'
import PatientModel from '@/model/PatientModel'
import { GenericAPIHandler } from '@/components/shared/GenericAPIHandler'

export default {
  name: 'PatientEdit',
  mixins: [GenericAPIHandler],
  components: {
    PatientInfoForm,
  },
  mounted () {
    this.getPatient()
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
    navigateTo: {
      type: String,
      required: true,
    },
    tabDefault: {
      type: String,
      required: false,
    },
  },
  data () {
    return {
      patient: {},
      fullscreenLoading: false,
      control: {
        showCancelCreateDialog: false,
      },
    }
  },
  methods: {
    async getPatient () {
      try {
        const raw = await this.$api.Patient.prepareupdate(this.id)
        this.patient = PatientModel.fromJSON(raw).woundCareDisplay()
      } catch (error) {
        this.showErrorDialog(error)
      }
    },
    cancelEditPatient () {
      this.control.showCancelCreateDialog = true
    },
    handleCancel (status) {
      if (status) {
        this.$router.push({ name: this.navigateTo, params: { id: this.id }, query: { tab: 'patientinfoTab' } })
      }
      this.control.showCancelCreateDialog = false
    },
    async editPatient (patient) {
      try {
        this.fullscreenLoading = true
        await this.$api.Patient.update(this.clearWoundCareData(patient))
        this.showSuccessDialog({ name: this.navigateTo, params: { id: this.id }, query: { tab: 'patientinfoTab' } })
      } catch (error) {
        this.showErrorDialog(error)
      } finally {
        this.fullscreenLoading = false
      }
    },
    clearWoundCareData (patient) {
      patient.skills = patient.skills.filter((item) => {
        return item !== 'woundCare'
      })
      switch (patient.skillOptions.woundCare.level) {
        case 1:
          patient.skills.push('woundCareLevel1')
          break
        case 2:
          patient.skills.push('woundCareLevel2')
          break
        case 3:
          patient.skills.push('woundCareLevel3')
          break
        case 4:
          patient.skills.push('woundCareLevel4')
          break
      }
      patient.skillOptions.woundCare.level = 0
      return patient
    },
  },
}
</script>
